// Reverse mapping of ../sizeConstants file.
export const mensTopSize = new Map([
  ['XS', 35],
  ['S', 37],
  ['M', 39],
  ['L', 41],
  ['XL', 44],
  ['XXL', 47],
]);

export const mensBottomSize = new Map([
  ['XS', 27],
  ['S', 29],
  ['M', 31],
  ['L', 33],
  ['XL', 36],
  ['XXL', 39],
]);

export const apparelSize = new Map([
  ['XXS', 2],
  ['XS', 4],
  ['S', 6],
  ['M', 8],
  ['L', 10],
  ['XL', 14],
  ['XXL', 18],
  ['XXS/XS', 2],
  ['L/XL', 10],
  ['XL/XXL', 14],
  ['1X', 19],
  ['2X', 20],
  ['3X', 22],
  ['4X', 24],
]);

const getMensSizeMaps = (category) => {
  if (category === 'top-size') {
    return mensTopSize;
  }

  return mensBottomSize;
};

export const getSizes = (isMens, category) => {
  if (isMens) {
    return getMensSizeMaps(category);
  }
  return apparelSize;
};

export const getSizeByKey = ({ isMens, category, key }) => {
  if (category === 'size_shoe') {
    return Number(key);
  }

  const sizes = getSizes(isMens, category);
  return sizes.get(key);
};
